module.exports = __webpack_public_path__ + "img/item-evaluation.87c097f6.png";